
import { defineComponent } from "vue";
import RoutesService from "@/api/Administration/RoutesService";
import store from "@/store";
import { IRoutesModel } from "@/interfaces/modules";

export default defineComponent({
  name: "SystemRoutesScreen",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as IRoutesModel,
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Name", label: "Nombre", sortable: true },
          { key: "Path", label: "Ruta", sortable: true },
          { key: "MenuName", label: "Menú", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true }
        ],
        records: [] as IRoutesModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): IRoutesModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
            (item) =>
              item.Name?.toLowerCase().includes(search) ||
              item.Path?.toLowerCase().includes(search)
          )
        : this.table.records;
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await RoutesService.GetRoute();
      this.table.loading = false;
    },
    async edit(item: IRoutesModel) {
      this.form.record = await RoutesService.GetRouteById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as IRoutesModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await RoutesService.PostRoute(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
